module.exports = __webpack_public_path__ + "img/e42.fc48acf3.png";